import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectAllowSignIn,
  makeSelectSiteCopy,
} from 'containers/Main/selectors';
import { makeSelectProcessing } from 'containers/Resources/selectors';
import Rating from 'components/Rating';
import LoadingIndicator from 'components/LoadingIndicator';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Grid from '@material-ui/core/Grid';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { getFormattedType } from 'components/ResourceItemSelector/utils';
import MixPanel from 'utils/mixpanelService';
import Button from '@material-ui/core/Button';
import { makeSelectAuth, makeSelectAuthModal } from 'containers/Auth/selectors';
import { setAuthModalState } from 'containers/Auth/actions';
import _capitalize from 'lodash/capitalize';
import ReviewIcon from './images/review.svg';
const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: 20,
  },
  ratingWrapper: {
    display: 'flex',
  },
  rootContent: {
    background: '#fff',
    padding: 20,
  },
  buttonRoot: {
    ...theme.typography.overline,
    height: 39,
    width: 128,
    color: theme.palette.primary.main,
    border: '1px solid #E0E0E0',
    borderRadius: 2,
    '&:hover': {
      backgroundColor: '#F8F9F9',
    },
  },
  reviewIcon: {
    marginRight: 8,
  },
  popper: {
    zIndex: 998,
    width: 340,
    background: 'white',
    border: `1px solid #E9ECED`,
    boxShadow: '0 2px 14px 0 rgba(0,0,0,0.05)',
    marginTop: 10,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      right: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%',
      },
    },
  },
  arrow: {
    overflow: 'hidden',
    position: 'absolute',
    width: '1em',
    height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
    boxSizing: 'border-box',
    color: 'white',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg)',
    },
  },
  btn: {
    width: '100%',
    margin: '6px 0',
    backgroundColor: 'white',
    height: 48,
    border: `1px solid #E3E3E3`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30.5,
  },
  textArea: {
    borderColor: '#E9ECED',
    borderRadius: 2,
    marginBottom: 11,
    width: '100%',
    padding: '12px 18px',
    marginTop: 15,
    fontSize: 12,
    lineHeight: '18px',
    fontFamily: 'MadaRegular',
  },
  reviewButton: {
    padding: 0,
    borderRadius: 2,
    height: 29,
    width: 113,
    fontSize: 12,
    fontFamily: 'MadaBold',
  },
  reviewButtonDisabled: {
    color: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
  submitBtnWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  successMessage: {
    color: '#1F8E1D',
    paddingTop: 12,
    display: 'block',
  },
  errorMessage: {
    color: '#D84A4A',
    paddingTop: 12,
    display: 'block',
  },
  title: {
    fontSize: 17,
    fontFamily: 'PoppinsSemiBold',
    lineHeight: '22px',
    marginBottom: 6,
  },
  subTitle: {
    fontSize: 14,
    lineHeight: '18px',
    marginBottom: 13,
  },
  ratingValue: {
    marginLeft: 6,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 998,
  },
  loadingBackdrop: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#FFFFFF',
    opacity: 0.4,
  },
});

class WriteReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      arrowRef: null,
      review: (props.review && props.review.review) || '',
      rate: null,
      showReviewMessage: false,
      errorMessage: '',
    };
    this.reviewSent = false;
    this.triggerOpenPopover = null;
    this.triggerScrollToReview = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { review } = this.props;
    // Update derived state when review text is updated
    const currentReviewText = _get(review, 'review');
    const reviewText = _get(nextProps, 'review.review');

    if (!_isEmpty(reviewText) && reviewText !== currentReviewText) {
      this.setState({
        review: reviewText,
      });
    }

    if (
      _get(review, 'rating') === _get(nextProps, 'review.rating') &&
      !_isEmpty(nextProps.review) &&
      review !== nextProps.review
    ) {
      this.setState({
        showReviewMessage: this.reviewSent,
      });
      setTimeout(() => {
        this.setState({ showReviewMessage: false });
      }, 4000);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { isLoaded, isEmpty },
      authModal,
    } = prevProps;

    const { open } = prevState;

    const isPopoverOpening = this.state.open && this.state.open !== open;
    if (isPopoverOpening) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ rate: null });
    }

    const isAuthModalClosing = authModal.show && !this.props.authModal.show;
    if (isAuthModalClosing && this.triggerScrollToReview) {
      this.triggerScrollToReview = false;
      this.handleToggle();
    }

    if (!this.triggerOpenPopover) return;

    const { auth } = this.props;
    if (isAuthModalClosing && auth.isLoaded && auth.isEmpty) {
      this.triggerOpenPopover = null;
      return;
    }

    const isSignedIn = auth.isLoaded && !auth.isEmpty;

    const authUpdated = isLoaded !== auth.isLoaded || isEmpty !== auth.isEmpty;
    if (authUpdated && isSignedIn) {
      this.triggerScrollToReview = true;
      this.triggerOpenPopover = null;
    }
  }

  handleRatingClick = (_, newValue) => {
    this.setState({ rate: newValue, errorMessage: '' });
    this.props.rate(newValue);
  };

  handleReviewSubmit = e => {
    e.preventDefault();

    const { sendReview, data, review: fullReview, siteCopy } = this.props;
    const { review, rate } = this.state;

    // If submit is clicked without review text, only close the popover
    if (!review) {
      this.setState({ open: false });
      return;
    }

    const ratingValue = rate || (fullReview ? fullReview.rating : 0);
    const [userReviewSiteCopy] = siteCopy.filter(
      el => el.slug === 'user-reviews',
    );

    if (!ratingValue) {
      // Please select a rating first.
      this.setState({
        errorMessage: _get(
          userReviewSiteCopy,
          'pageCopy.reviewModalSelectRatingError',
          '',
        ),
      });
      return;
    }

    this.setState({
      errorMessage: '',
    });

    const {
      fields: { name, title, blog, type: resourceSubtype },
      sys,
      sys: { id },
    } = data[0];
    const type = getFormattedType(sys.contentType.sys.id);
    let subtype;
    if (type === 'app') {
      if (resourceSubtype === 'Online Therapy') subtype = resourceSubtype;
      else subtype = 'Apps';
    }
    if (type === 'organization') {
      subtype = resourceSubtype;
    }
    if (type === 'read') {
      subtype = resourceSubtype;
    }
    MixPanel.track('Review This', {
      name: name || title,
      type,
      blog,
      subtype,
      review,
      rating: _get(fullReview, 'rating') || 0,
      entryId: id,
    });
    this.reviewSent = true;
    sendReview(review);
  };

  shouldShowAuth = () => {
    const { open } = this.state;
    const { auth, dispatch } = this.props;

    if (!open && auth.isLoaded && auth.isEmpty) {
      this.triggerOpenPopover = true;
      dispatch(setAuthModalState({ show: true, type: 'rate' }));
      return true;
    }
    return false;
  };

  handleToggle = () => {
    const { open } = this.state;
    const { data } = this.props;
    const {
      fields: { name, title, type },
      sys: { id },
    } = data[0];

    // We don't want to toggle the popover, if user is not signed in
    if (this.shouldShowAuth()) {
      return;
    }

    this.setState(
      { open: !open, showReviewMessage: false, errorMessage: '' },
      () => {
        if (this.state.open) {
          if (this.anchorEl) {
            window.scrollTo({
              top:
                this.anchorEl.getBoundingClientRect().top +
                window.pageYOffset -
                160,
              behavior: 'smooth',
            });
          }
          MixPanel.track('Write a Review - Clicked', {
            name: name || title,
            path: window.location.pathname,
            type,
            entryId: id,
          });
        }
      },
    );
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const {
      classes,
      data,
      allowSignIn,
      review: fullReview,
      processing,
      siteCopy,
    } = this.props;
    const [userReviewSiteCopy] = siteCopy.filter(
      el => el.slug === 'user-reviews',
    );
    const [resourceItemPageSiteCopy] = siteCopy.filter(
      el => el.slug === 'resource-item-page',
    );
    const { sys } = data[0] || {};
    const contentType = _get(sys, 'contentType.sys.id');
    const hideReview = ['organization', 'person'].includes(contentType);
    const {
      open,
      arrowRef,
      review,
      showReviewMessage,
      rate,
      errorMessage,
    } = this.state;
    const disableSubmitButton = !rate && !review;

    const ratingValue = rate || (fullReview ? fullReview.rating : 0);
    const type = _get(resourceItemPageSiteCopy, [
      'pageCopy',
      'resourceTypeMapping',
      getFormattedType(sys.contentType.sys.id).toUpperCase(),
    ]);
    return (
      <div className={classes.root}>
        <Button
          variant="outlined"
          ref={node => {
            this.anchorEl = node;
          }}
          aria-owns={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={this.handleToggle}
          classes={{ root: classes.buttonRoot }}
          disableRipple
          disableTouchRipple
        >
          <img src={ReviewIcon} alt="" className={classes.reviewIcon} />
          {_get(userReviewSiteCopy, 'pageCopy.reviewButtonLabel', '')}
        </Button>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          transition
          disablePortal
          placement="bottom-end"
          modifiers={{
            arrow: {
              enabled: true,
              element: arrowRef,
            },
            flip: {
              enabled: false,
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <>
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <ClickAwayListener onClickAway={this.handleClose}>
                  <Grid container className={classes.rootContent}>
                    {processing && (
                      <div className={classes.loadingOverlay}>
                        <div className={classes.loadingBackdrop} />
                        <LoadingIndicator />
                      </div>
                    )}
                    {allowSignIn && !hideReview && (
                      <>
                        <Grid item xs={12}>
                          <Typography
                            color="textPrimary"
                            className={classes.title}
                          >
                            {_get(
                              userReviewSiteCopy,
                              'pageCopy.reviewModalHeader',
                              '',
                            ).replace('#type', _capitalize(type))}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            className={classes.subTitle}
                            color="textPrimary"
                          >
                            {_get(
                              userReviewSiteCopy,
                              'pageCopy.reviewModalBody',
                              '',
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.ratingWrapper}>
                          <Rating
                            name={`${contentType}-rating`}
                            value={ratingValue}
                            precision={0.5}
                            readOnly={false}
                            onChange={this.handleRatingClick}
                            isBig
                          />
                          {parseFloat(ratingValue, 10) > 0 && (
                            <span className={classes.ratingValue}>
                              {parseFloat(ratingValue, 10).toFixed(1)}
                            </span>
                          )}
                        </Grid>
                        {showReviewMessage && (
                          <Grid item xs={12}>
                            <Typography
                              variant="overline"
                              className={classes.successMessage}
                            >
                              {_get(
                                userReviewSiteCopy,
                                'pageCopy.reviewModalSuccessMessage',
                                '',
                              )}
                            </Typography>
                          </Grid>
                        )}

                        {errorMessage && (
                          <Grid item xs={12}>
                            <Typography
                              variant="overline"
                              className={classes.errorMessage}
                            >
                              {errorMessage}
                            </Typography>
                          </Grid>
                        )}

                        <Grid item xs={12}>
                          <textarea
                            value={review}
                            onChange={e =>
                              this.setState({ review: e.target.value })
                            }
                            placeholder={_get(
                              userReviewSiteCopy,
                              'pageCopy.reviewModalPlaceholder',
                              '',
                            )}
                            cols={40}
                            rows={5}
                            className={classes.textArea}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.submitBtnWrapper}>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={disableSubmitButton}
                            onClick={this.handleReviewSubmit}
                            classes={{
                              root: classes.reviewButton,
                              disabled: classes.reviewButtonDisabled,
                            }}
                            disableRipple
                            disableElevation
                          >
                            {_get(fullReview, 'review')
                              ? _get(
                                  userReviewSiteCopy,
                                  'pageCopy.reviewModalUpdateLabel',
                                  '',
                                )
                              : _get(
                                  userReviewSiteCopy,
                                  'pageCopy.reviewModalSubmitLabel',
                                  '',
                                )}
                          </Button>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </ClickAwayListener>
              </>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

WriteReview.propTypes = {
  allowSignIn: PropTypes.bool,
  classes: PropTypes.object,
  data: PropTypes.array,
  rate: PropTypes.func,
  review: PropTypes.object,
  sendReview: PropTypes.func,
  id: PropTypes.string,
  isAdmin: PropTypes.bool,
  processing: PropTypes.bool,
  siteCopy: PropTypes.array,
  auth: PropTypes.object,
  authModal: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
  processing: makeSelectProcessing(),
  siteCopy: makeSelectSiteCopy(),
  auth: makeSelectAuth(),
  authModal: makeSelectAuthModal(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withStyles(styles),
  withRouter,
  withConnect,
)(memo(WriteReview));
